module.exports = __webpack_public_path__ + "img/926.f8d786a9.jpg";